function showBusinessField() {
  if($('input[name=invoice_type]:checked').val() == 'business') {
    $('.business-field').removeClass('hidden');
  } else {
    $('.business-field').addClass('hidden');
  }
}
$(function() {
  if($('input[name=invoice_type]').length) {
    showBusinessField();
  }
  $('input[name=invoice_type]').on('change', showBusinessField);
});
